import { render, staticRenderFns } from "./BookingAddressListItem.vue?vue&type=template&id=667b1fef&"
import script from "./BookingAddressListItem.vue?vue&type=script&lang=js&"
export * from "./BookingAddressListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports